import { Skeleton } from "@material-ui/lab";
import React from "react";

const TableFilterItemSkeleton = () => {
    return <Skeleton width="100%" height={60} />;
};

export default TableFilterItemSkeleton;
